import { APP_FILLER } from 'src/constants';
import { all, concat, curry, equals, join, pipe, values } from 'ramda';

export const generatePassword = (suffix: string) => {
  const prefix = APP_FILLER;
  // use the APP_FILLER as prefix, for example, "Lendsmart", and then the unique id, and in the last
  // append with a special character. An example password would be Lendsmart32453412423245343%
  return `${prefix.charAt(0).toUpperCase() + prefix.slice(1)}${suffix}${specials.charAt(4)}`;
};

const specials = '!@#$%^&*()_+{}:"<>?\|[];\',./`~';
const lowercase = 'abcdefghijklmnopqrstuvwxyz';
const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const numbers = '0123456789';


const randamCharSet = (chars: string, len: number) => {
  let randomstring = '';
  for (let i = 0; i < len; i++) {
    const rnum = Math.floor(Math.random() * chars.length);
    randomstring = concat(randomstring, chars.substring(rnum, rnum + 1));
  }
  return randomstring
}

const shuffle = (ls: any) => {
  const shuffler = curry((random, list) => {
    let idx = -1;
    const len = list.length;
    let position;
    const result: any = [];
    while (++idx < len) {
      position = Math.floor((idx + 1) * random());
      result[idx] = result[position];
      result[position] = list[idx];
    }
    return result;
  })
  return shuffler(Math.random)(ls);
}


export const generateRandomPassword = () => {
  const all = specials + lowercase + uppercase + numbers;

  let password = '';
  password += randamCharSet(uppercase, 4)
  password += randamCharSet(specials, 3)
  password += randamCharSet(lowercase, 4)
  password += randamCharSet(numbers, 3)
  password += randamCharSet(all, 4);
  return join('', shuffle(password))
}

export const validatePassword = (value: string, strongMinCharPassword: number) => {
  const updatedValidators = {
    hasUppercase: /.*[A-Z].*$/.test(value),
    hasLowercase: /.*[a-z].*$/.test(value),
    hasSpecialChar: /.*\W.*$/.test(value),
    hasNumber: /.*\d.*$/.test(value),
    has8min: value.length >= strongMinCharPassword,
    has32Max: value.length <= 32,
  };
  return updatedValidators;
}

export type formValidationType = {
  hasLowercase: boolean,
  hasUppercase: boolean,
  hasSpecialChar: boolean,
  hasNumber: boolean,
  has8min: boolean,
  has32Max: boolean,
}

export const checkValidPassword = (formValidation: formValidationType) => {
  const isValidPassword = pipe(values, all(equals(true)))(formValidation);
  return isValidPassword;
}